import OrbitApiV1 from '.'

class BillAPI {
  static getBillPdf(billNo) {
    return OrbitApiV1.httpDownload(`/bill/${billNo}/pdf`, `${billNo}.pdf`)
  }

  static getOrgBills(orgId, startDate, endDate, limit) {
    return OrbitApiV1.httpGet(
      `/bill/${orgId}/bills?startDate=${startDate}&endDate=${endDate}&limit=${limit}`
    )
  }

  static generateBills() {
    return OrbitApiV1.httpGet(`/bill/generateBills`, {}, false)
  }

  static getAllBills(startDate, endDate) {
    return OrbitApiV1.httpGet(
      `/bill/list/all?startDate=${startDate}&endDate=${endDate}`
    )
  }

  static updateBill(billId) {
    return OrbitApiV1.httpPut(`/bill/update-bill/${billId}`, {}, {})
  }
}

export default BillAPI
